
import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class EllipseArcEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITELLIPSEARC;
}